import React from 'react'
const Android_Development = () => {
    return (
        <>
            <section className="web_development">
                <div className="container">
                    <div className="content">
                        <h2>Android</h2>
                        <h1>DEVELOPMENT</h1>
                    </div>
                </div>
            </section>
            <section className="web_development1">
                <div className="container py-5">
                    <div className="row d-flex align-items-center">
                        <div className="col-lg-4">
                            <img src="img/app.png" className='img-fluid' alt="Website" />
                        </div>
                        <div className="col-lg-8">
                            <div className="content">
                                <h2>Interactive Android Development Solutions</h2>
                                <p style={{ textAlign: "justify" }}>Muhammad Rizwan create apps for a variety of reasons. They may need to address business requirements or build new services or businesses, or they may want to offer games and other types of content for users. Developers choose to develop for Android in order to reach the majority of mobile device users,or build new services or businesses, or they may want to offer games and other types of content for users. Developers choose to develop for Android in order to reach the majority of mobile device users.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="web_development2">
                <div className="container">
                    <div className="content">
                        <h6>SERVICES</h6>
                        <h1>FUNCTIONAL  <span style={{ color: "#30ADA7", fontFamily: "heading" }}>ANDROID APP </span>INTERFACES</h1>
                        <p>Muhammad Rizwan loves transforming creative ideas into graphic visuals that represent the best of your core values, with no compromise on usability and uniqueness. We look to redefine the digital landscape by using result-driven processes to pitch your presence on Android.</p>
                    </div>
                </div>
            </section>
            <section className="web_development3">
                <div className="container">
                    <div className="row py-5">
                        <div className="col-lg-4 col-md-6 my-2 d-flex align-items-stretch">
                            <div className="card p-3 text-center">
                                <center><img src="img/native-android.png" width={50} alt="Native" /></center>
                                <h4 className='text-white py-1'>Native Android Development</h4>
                                <p style={{ textAlign: "justify" }}>The term native app development refers to building a mobile app exclusively for a single platform. The app is built with programming languages and tools that are specific to a single platform. For example, you can develop a native Android.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 my-2 d-flex align-items-stretch">
                            <div className="card p-3 text-center">
                                <center><img src="img/cross-platform.png" width={50} alt="cross" /></center>
                                <h4 className='text-white py-1'>Cross-Platform Development</h4>
                                <p style={{ textAlign: "justify" }}>The term “cross-platform mobile app development” or “hybrid mobile app development” speaks for itself: this is an approach that allows developers to build a mobile solution that is simultaneously compatible with several operating systems and platforms (Android).</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12 my-2 d-flex align-items-stretch">
                            <div className="card p-3 text-center">
                                <center><img src="img/android-character.png" width={50} alt="android" /></center>
                                <h4 className='text-white py-1'>Android Game Development</h4>
                                <p style={{ textAlign: "justify" }}>The Android Game Development (AGD) is a full range of tools and libraries to help you develop, optimize, launch, and iterate on high quality Android games. AGDK brings together new and existing libraries, tools and functionality.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default Android_Development